import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResourceManagerService } from './logic/resource-manager.service';
import { ResourceManagerLogicService } from './logic/resource-manager/resource-manager-logic.service';
import { IdentityServerStorageDaoService } from './dao/identity-server-storage-dao/identity-server-storage-dao.service';
import { IdentityServerDaoService } from './dao/identity-server-dao.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: ResourceManagerService, useClass: ResourceManagerLogicService },
    {
      provide: IdentityServerDaoService,
      useClass: IdentityServerStorageDaoService,
    },
  ],
})
export class ResourceManagerModule {}
